/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgBankingViewModelGen,
  ThgCreateThgAndUserDtoGen,
  ThgCreateThgImageDtoGen,
  ThgCreateThgVehicleDtoGen,
  ThgExceptionViewmodelGen,
  ThgImageIdViewmodelGen,
  ThgPageViewModelGen,
  ThgRegistrationDtoGen,
  ThgThgBonusViewmodelGen,
  ThgThgControllerFindAllAsAdminParamsGen,
  ThgThgControllerFindAllPaginatedParamsGen,
  ThgThgControllerUpdateStatusParamsGen,
  ThgThgControllerUploadImageQueryParamsGen,
  ThgThgViewModelGen,
  ThgTransferThgDtoGen,
  ThgUpdateThgAdminDtoGen,
  ThgUpdateThgDtoGen,
  ThgUpdateThgRegistrationImagesDtoGen,
  ThgUpdateThgStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Thg<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerBonus
   * @summary Get the Thg Bonus.
   * @request GET:/thg/bonus
   * @response `200` `ThgThgBonusViewmodelGen` The Thg Bonus
   * @response `400` `void` General error if request is not working.
   */
  thgControllerBonus = (params: RequestParams = {}) =>
    this.http.request<ThgThgBonusViewmodelGen, void>({
      path: `/thg/bonus`,
      method: "GET",
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerFindMyThgs
   * @summary Get my registered Thgs.
   * @request GET:/thg/me
   * @secure
   * @response `200` `(ThgThgViewModelGen)[]` The id of the image
   * @response `400` `void` General error if request is not working.
   */
  thgControllerFindMyThgs = (params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen[], void>({
      path: `/thg/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUpdateMyThg
   * @summary Update a specifc THG Document of my documents
   * @request PATCH:/thg/me/{thgId}
   * @secure
   * @response `200` `ThgThgViewModelGen` The updatet THG Document
   * @response `400` `void` General error if request is not working.
   */
  thgControllerUpdateMyThg = (thgId: string, data: ThgUpdateThgDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/thg/me/${thgId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerAddRegistrationToMyThg
   * @summary Update Registration Informations of my THG Document
   * @request POST:/thg/me/{thgId}/registration
   * @secure
   * @response `200` `ThgThgViewModelGen` The updatet THG Document
   * @response `400` `void` General error if request is not working.
   */
  thgControllerAddRegistrationToMyThg = (thgId: string, data: ThgRegistrationDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/thg/me/${thgId}/registration`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUpdateMyRegistrationImages
   * @summary Update Registration Images of the Thg Document
   * @request PATCH:/thg/me/{thgId}/registrationImages
   * @secure
   * @response `200` `ThgThgViewModelGen` The updated thg document
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found.
   * @response `409` `ThgExceptionViewmodelGen` Conflict, e.g if image is already used or updating registration images is not allowed due to current status.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  thgControllerUpdateMyRegistrationImages = (
    thgId: string,
    data: ThgUpdateThgRegistrationImagesDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgThgViewModelGen, ThgExceptionViewmodelGen>({
      path: `/thg/me/${thgId}/registrationImages`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerFindAllAsAdmin
   * @summary Gets all Thgs (ADMIN Route)
   * @request GET:/thg/all
   * @secure
   * @response `200` `(ThgThgViewModelGen)[]` The found records
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  thgControllerFindAllAsAdmin = (query: ThgThgControllerFindAllAsAdminParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen[], ThgExceptionViewmodelGen>({
      path: `/thg/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerGetWorkItem
   * @summary Get a Workitem to work on
   * @request GET:/thg/nextworkitem
   * @secure
   * @response `200` `ThgThgViewModelGen` The id of the image
   * @response `400` `void` General error if request is not working.
   */
  thgControllerGetWorkItem = (params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/thg/nextworkitem`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerNewThg
   * @summary Registrate a User and a thg.
   * @request POST:/partner/{partnerId}/thg/new
   * @response `200` `ThgThgViewModelGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  thgControllerNewThg = (partnerId: string, data: ThgCreateThgAndUserDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/new`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerAddThg
   * @summary Registrate an additional thg
   * @request POST:/partner/{partnerId}/thg
   * @secure
   * @response `200` `ThgThgViewModelGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  thgControllerAddThg = (partnerId: string, data: ThgCreateThgVehicleDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerFindAll
   * @summary Gets all Thgs for a given partnerid
   * @request GET:/partner/{partnerId}/thg
   * @secure
   * @response `200` `(ThgThgViewModelGen)[]` The found records
   * @response `403` `void` Forbidden.
   */
  thgControllerFindAll = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen[], void>({
      path: `/partner/${partnerId}/thg`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUploadImageQuery
   * @summary Submit image for an registration
   * @request POST:/partner/{partnerId}/thg/addimage
   * @response `200` `ThgImageIdViewmodelGen` The id of the image
   * @response `400` `void` General error if request is not working.
   * @response `404` `void` No partner found.
   */
  thgControllerUploadImageQuery = (
    { partnerId, ...query }: ThgThgControllerUploadImageQueryParamsGen,
    data: ThgCreateThgImageDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgImageIdViewmodelGen, void>({
      path: `/partner/${partnerId}/thg/addimage`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerFindAllPaginated
   * @summary (ADMIN) Gets all thgs for all partners paginated
   * @request GET:/thg
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgThgViewModelGen)[] })`
   * @response `403` `void` Forbidden.
   */
  thgControllerFindAllPaginated = (query: ThgThgControllerFindAllPaginatedParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgThgViewModelGen[] }, void>({
      path: `/thg`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerFind
   * @summary Gets a specific Thg
   * @request GET:/partner/{partnerId}/thg/{thgId}
   * @secure
   * @response `200` `ThgThgViewModelGen` The requested thg document
   * @response `403` `void` Forbidden.
   */
  thgControllerFind = (partnerId: string, thgId: string, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUpdate
   * @summary Updates a specific Thg
   * @request PATCH:/partner/{partnerId}/thg/{thgId}
   * @secure
   * @response `200` `ThgThgViewModelGen` The updated thg document
   * @response `403` `void` Forbidden.
   */
  thgControllerUpdate = (partnerId: string, thgId: string, data: ThgUpdateThgAdminDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerTransfer
   * @summary Transfer a THG-Document to another partner
   * @request PATCH:/partner/{partnerId}/thg/{thgId}/transfer
   * @secure
   * @response `200` `ThgThgViewModelGen` The transfered thg document
   * @response `403` `void` Forbidden.
   */
  thgControllerTransfer = (partnerId: string, thgId: string, data: ThgTransferThgDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}/transfer`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerGetBankingInformation
   * @summary Gets a specific Bankinginformation to a THG Document
   * @request GET:/partner/{partnerId}/thg/{thgId}/banking
   * @secure
   * @response `200` `ThgBankingViewModelGen` The requested bankingdocument asigend to the user
   * @response `403` `void` Forbidden.
   */
  thgControllerGetBankingInformation = (partnerId: string, thgId: string, params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}/banking`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUpdateStatus
   * @summary Change the Status of a ThgDocument
   * @request PATCH:/partner/{partnerId}/thg/{thgId}/status
   * @secure
   * @response `200` `ThgThgViewModelGen` The requested thg document
   * @response `403` `void` Forbidden.
   */
  thgControllerUpdateStatus = (
    { partnerId, thgId, ...query }: ThgThgControllerUpdateStatusParamsGen,
    data: ThgUpdateThgStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}/status`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerAddRegistration
   * @summary Update Registration Information of the Thg Document
   * @request PATCH:/partner/{partnerId}/thg/{thgId}/registration
   * @secure
   * @response `200` `ThgThgViewModelGen` The updated thg document
   * @response `403` `void` Forbidden.
   */
  thgControllerAddRegistration = (
    partnerId: string,
    thgId: string,
    data: ThgRegistrationDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgThgViewModelGen, void>({
      path: `/partner/${partnerId}/thg/${thgId}/registration`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags thg
   * @name ThgControllerUpdateRegistrationImages
   * @summary Update Registration Images of the Thg Document
   * @request PATCH:/partner/{partnerId}/thg/{thgId}/registrationimages
   * @secure
   * @response `200` `ThgThgViewModelGen` The updated thg document
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found.
   * @response `409` `ThgExceptionViewmodelGen` Conflict, e.g if image is already used.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  thgControllerUpdateRegistrationImages = (
    partnerId: string,
    thgId: string,
    data: ThgUpdateThgRegistrationImagesDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgThgViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/thg/${thgId}/registrationimages`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
